import React from 'react';

const ManageOrder = () => {
    return (
        <div>
            <h2>Manage order</h2>
        </div>
    );
};

export default ManageOrder;